import RowV3 from './Row.v3'

export default RowV3
// eslint-disable-next-line import/export
export * from './Row.v3'
